import { useState as d, useCallback as u, useMemo as v, useRef as l, useEffect as I, useLayoutEffect as x } from "react";
import { getPopupPosition as B } from "./utils.js";
const P = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: 0,
  height: 0
};
function q({
  hover: t,
  position: r,
  closeDelay: c,
  boundingElementRef: o,
  enabled: s,
  onClosePopup: e
}) {
  const [n, a] = d(!1), [i, p] = d(P), [h, k] = d(P), f = u(() => a(!0), []), m = u(() => {
    a(!1), e == null || e();
  }, [e]), M = (o == null ? void 0 : o.current) || document.body, D = u(
    (L) => {
      const C = B(r, {
        anchor: i,
        popup: L,
        boundingRect: M.getBoundingClientRect()
      });
      k({ ...L, ...C });
    },
    [r, i, M]
  ), T = j(p), {
    onMouseEnterAnchor: g,
    onMouseLeaveAnchor: w,
    onMouseEnterPopup: A,
    onMouseLeavePopup: E
  } = S({
    openPopup: f,
    closePopup: m,
    closeDelay: c
  }), O = v(() => t ? {
    onClick: n ? m : f,
    onMouseEnter: g,
    onMouseLeave: w
  } : {
    onClick: n ? m : f
  }, [
    t,
    g,
    w,
    f,
    m,
    n
  ]), b = v(() => t ? {
    onMouseEnter: A,
    onMouseLeave: E
  } : {}, [t, A, E]);
  return {
    openPopup: f,
    closePopup: m,
    isOpen: s && n,
    anchor: i,
    popup: h,
    setPopupDimensions: D,
    anchorRef: T,
    anchorProps: O,
    popupProps: b
  };
}
function S({ openPopup: t, closePopup: r, closeDelay: c }) {
  const o = l(!1), s = l(!1), e = l(null), n = u(() => {
    clearTimeout(e.current), e.current = setTimeout(() => {
      !o.current && !s.current && r();
    }, c);
  }, [c, r]), a = u(() => {
    t(), o.current = !0;
  }, [t]), i = u(() => {
    o.current = !1, n();
  }, [n]), p = u(() => {
    s.current = !0;
  }, []), h = u(() => {
    s.current = !1, n();
  }, [n]);
  return {
    onMouseEnterAnchor: a,
    onMouseLeaveAnchor: i,
    onMouseEnterPopup: p,
    onMouseLeavePopup: h
  };
}
function z({
  isOpen: t,
  closePopup: r,
  closeOnPopupClick: c,
  popupRef: o
}) {
  const s = u(
    (e) => {
      var n;
      (c || !(e.target instanceof Node && ((n = o.current) != null && n.contains(e.target)))) && r();
    },
    [c, o, r]
  );
  I(() => {
    const e = setTimeout(() => {
      t ? window.addEventListener("click", s) : window.removeEventListener("click", s);
    }, 0);
    return () => {
      clearTimeout(e), window.removeEventListener("click", s);
    };
  }, [t, s]);
}
function j(t) {
  const r = l(null), c = y(r), { height: o, width: s, left: e, top: n, right: a, bottom: i } = c;
  return x(() => {
    r.current && t({
      height: o,
      width: s,
      left: e,
      top: n,
      right: a,
      bottom: i
    });
  }, [t, o, s, e, n, i, a]), r;
}
function y(t) {
  return !t || !t.current ? {
    height: 0,
    width: 0,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : t.current.getBoundingClientRect();
}
export {
  z as useAutoCloseOnClick,
  q as useContextPopupState,
  j as useElementDimensions
};
